import { PropsWithChildren } from "react"
import { Text } from "@tm/controls"

export function AutosuggestHit({ children }: PropsWithChildren<{}>) {
    return <Text modifiers="strong">{children}</Text>
}
